import { Button, message } from 'antd';
import { Check, Copy } from 'lucide-react';
import { useState } from 'react';

const EXAMPLE_TEXT =
  'Focaccia, Ricotta, honey, olive & Balsamic - This focaccia is proved for three days giving it a gentle sour flavour. The ricotta is freshly made and has hints of cider vinegar, through the ricotta there are little bursts of balsamic vinegar and honey. the savoury element is nocellara olives (young refreshing olives)';

export function ExampleCard() {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text: string) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
        } finally {
          textArea.remove();
        }
      }

      setIsCopied(true);
      message.success('Copied to clipboard');
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
      message.error('Please copy the text manually');
    }
  };

  return (
    <div className="w-full p-4 mb-2 rounded-lg bg-muted/30">
      <div className="text-sm font-medium mb-1 flex justify-between items-center">
        <span>Example of a good dish description:</span>
        <Button
          type="text"
          size="small"
          className="h-6 w-6 p-0"
          onClick={() => copyToClipboard(EXAMPLE_TEXT)}
        >
          {isCopied ? (
            <Check className="h-4 w-4" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </Button>
      </div>
      <button
        type="button"
        onClick={() => copyToClipboard(EXAMPLE_TEXT)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            copyToClipboard(EXAMPLE_TEXT);
          }
        }}
        className="w-full text-left text-sm text-muted-foreground italic hover:bg-muted/50 rounded p-2 transition-colors cursor-pointer"
      >
        "{EXAMPLE_TEXT}"
      </button>
    </div>
  );
}
